var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
/**
 * LoaderDots: Animated dots for loading indication in chat bubbles.
 * Uses Tailwind for animation and color with sequenced bouncing effect.
 */
export var LoaderDots = function () { return (_jsxs("span", __assign({ className: "flex h-[17px] items-center space-x-1", "aria-label": "Loading" }, { children: [_jsx("span", { className: "inline-block h-1 w-1 animate-bounce-dot1 rounded-full bg-gray-40" }), _jsx("span", { className: "inline-block h-1 w-1 animate-bounce-dot2 rounded-full bg-gray-40" }), _jsx("span", { className: "inline-block h-1 w-1 animate-bounce-dot3 rounded-full bg-gray-40" })] }))); };
